import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserRole } from '@core/models/admin/user-role';
import { firstValueFrom } from 'rxjs';
import { AnalyticReport } from '../models/admin/analytic-report';
import { ConfigService } from './config.service';

@Injectable()
export class AdminService {
  basePath = `${this.configService.appConfig.api.uoUrl}/admin`

  constructor(private readonly configService: ConfigService, private readonly httpClient: HttpClient) { }

  getUserRoles(): Promise<UserRole[]> {
    return firstValueFrom(this.httpClient.get<UserRole[]>(`${this.basePath}/roleList`));
  }

  getAnalyticReports(): Promise<AnalyticReport[]> {
    return firstValueFrom(this.httpClient.get<AnalyticReport[]>(`${this.basePath}/analyticReports`));
  }

}
